import { render } from "./AffiliateCard.vue?vue&type=template&id=56f8255e&scoped=true"
import script from "./AffiliateCard.vue?vue&type=script&lang=js"
export * from "./AffiliateCard.vue?vue&type=script&lang=js"

import "./AffiliateCard.vue?vue&type=style&index=0&id=56f8255e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f8255e"]])

export default __exports__